export const createProductsActions = (state) => {
    const normalizeArray = (items) => (Array.isArray(items) ? [...items] : [])

    // --- Products ---
    const setProducts = (items) => {
        state.products.value = normalizeArray(items)
    }

    const setProductsLoading = (value) => {
        state.productsLoading.value = Boolean(value)
    }

    const setProductsFilters = (filters = {}) => {
        state.productsFilters.value = {
            ...state.productsFilters.value,
            ...filters
        }
    }

    const resetProductsFilters = () => {
        state.productsFilters.value = state.createProductsFilters()
    }

    const setProductsMeta = (meta = {}) => {
        state.productsMeta.value = {
            ...state.productsMeta.value,
            ...meta
        }
    }

    // --- Product Edit View State ---
    const setCurrentProduct = (product) => {
        state.currentProduct.value = product
    }

    const setProductProductionProperties = (items) => {
        state.productProductionProperties.value = normalizeArray(items)
    }

    const setProductComponents = (items) => {
        state.productComponents.value = normalizeArray(items)
    }

    const setProductionProcesses = (items) => {
        state.productionProcesses.value = normalizeArray(items)
    }

    const setProductProperties = (items) => {
        state.productProperties.value = normalizeArray(items)
    }

    const setAllProductProperties = (items) => {
        state.allProductProperties.value = normalizeArray(items)
    }

    return {
        // Setters
        setProducts,
        setProductsLoading,
        setProductsFilters,
        resetProductsFilters,
        setProductsMeta,

        // Product Edit View Setters
        setCurrentProduct,
        setProductProductionProperties,
        setProductComponents,
        setProductionProcesses,
        setProductProperties,
        setAllProductProperties
    }
}
